<mat-horizontal-stepper #stepper>
    <mat-step [stepControl]="basicInformation" [label]="'CUSTOMER.basic_information' | translate">
        <form [formGroup]="basicInformation">
            <div class="row">
                <div class=" col-sm-12">
                    <mat-form-field appearance="outline">
                        <mat-label>{{"CUSTOMER..FULL_NAME" | translate}}</mat-label>
                        <input  matInput formControlName="fullName" required>
                        <mat-error *ngIf="hasError('fullName', 'required')">{{"CUSTOMER.FULL_NAME" | translate}}
                            {{"COMMON.required" | translate}} </mat-error>
                    </mat-form-field>
                </div>
                <div class=" col-sm-12">
                    <mat-form-field appearance="outline">
                        <mat-label>{{"CUSTOMER.EMAIL" | translate}}</mat-label>
                        <input matInput formControlName="email" required>
                        <mat-error *ngIf="hasError('email', 'required')">{{"CUSTOMER.EMAIL" | translate}}
                            {{"COMMON.required" | translate}} </mat-error>
                        <mat-error *ngIf="hasError('email', 'email')">{{"CUSTOMER.EMAIL" | translate}}
                            {{"COMMON.incorrect" | translate}} </mat-error>
                    </mat-form-field>
                </div>
                <div class=" col-sm-12">
                    <mat-form-field appearance="outline">
                        <mat-label>{{"CUSTOMER.cardNumber" | translate}}</mat-label>
                        <input matInput formControlName="nationalId" onlyNumber required>
                        <mat-error *ngIf="hasError('nationalId', 'required')">{{"CUSTOMER.cardNumber" | translate}}
                            {{"COMMON.required" | translate}} </mat-error>

                    </mat-form-field>
                </div>

                <div class=" col-sm-12">
                    <mat-form-field appearance="outline">
                        <mat-label>{{"CUSTOMER.PHONE_NUMBER" | translate}}</mat-label>
                        <input matInput formControlName="phoneNumber" required>
                        <mat-error *ngIf="hasError('phoneNumber', 'required')">{{"CUSTOMER.PHONE_NUMBER" | translate}}
                            {{"COMMON.required" | translate}} </mat-error>
                    </mat-form-field>
                </div>

                <div class=" col-sm-12">
                    <mat-form-field appearance="outline">
                        <mat-label>{{"CUSTOMER.customer'sـtrade" | translate}}</mat-label>
                        <input matInput formControlName="customerLegalEntityName" required>
                        <mat-error *ngIf="hasError('customerLegalEntityName', 'required')">{{"CUSTOMER.customer'sـtrade" | translate}}
                            {{"COMMON.required" | translate}} </mat-error>
                    </mat-form-field>
                </div>

                <div class=" col-sm-12">
                    <mat-form-field appearance="outline">
                        <mat-label>{{"CUSTOMER.customer'sـcommercialـnumber" | translate}}</mat-label>
                        <input matInput formControlName="customerLegalEntityNumber" required>
                        <mat-error *ngIf="hasError('customerLegalEntityNumber', 'required')">{{"CUSTOMER.customer'sـcommercialـnumber" | translate}}
                            {{"COMMON.required" | translate}} </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div>
                <button mat-button matStepperNext>{{"CUSTOMER.NEXT" | translate}}</button>
            </div>
        </form>
    </mat-step>

    <mat-step [stepControl]="thirdInformation" [label]="'CUSTOMER.ADDRESS' | translate">
        <ng-template matStepLabel>العنوان</ng-template>

        <form [formGroup]="thirdInformation">
            <div class="row">
                <div class=" col-sm-12">
                    <mat-form-field appearance="outline">
                        <mat-label>{{ "CUSTOMER.FORM.BRANCHES.FORM.COUNTRY" | translate }}
                        </mat-label>
                        <mat-select formControlName="country">
                            <mat-option *ngFor="let country of countries" [value]="country.id">
                                {{ country.name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="hasInformationError('country', 'required')">{{ "CUSTOMER.FORM.BRANCHES.FORM.COUNTRY" | translate}}
                            {{"COMMON.required" | translate}} </mat-error>
                    </mat-form-field>
                </div>
                <div *ngIf="validationThirdInformation.country.value > 0 && governorates.length > 0" class=" col-sm-12">
                    <mat-form-field appearance="outline">
                        <mat-label>{{ "CUSTOMER.FORM.BRANCHES.FORM.GOVERNORATE" | translate }}
                        </mat-label>
                        <mat-select formControlName="governorate">
                            <mat-option *ngFor="let governorate of governorates" [value]="governorate.id">
                                {{ governorate.name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="hasInformationError('governorate', 'required')">{{ "CUSTOMER.FORM.BRANCHES.FORM.GOVERNORATE" | translate}}
                            {{"COMMON.required" | translate}} </mat-error>
                    </mat-form-field>
                </div>
                <div *ngIf="validationThirdInformation.governorate.value > 0 && cities.length > 0 && governorates.length"
                    class="col-sm-12  col-sm-12">
                    <mat-form-field appearance="outline">
                        <mat-label>{{ "CUSTOMER.FORM.BRANCHES.FORM.CITY" | translate }}
                        </mat-label>
                        <mat-select formControlName="city">
                            <mat-option *ngFor="let city of cities" [value]="city.id">
                                {{ city?.name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="hasInformationError('city', 'required')">{{ "CUSTOMER.FORM.BRANCHES.FORM.CITY" | translate}}
                            {{"COMMON.required" | translate}} </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="innerMap">
                <div id="map">

                </div>
            </div>
        </form>

        <div>
            <button mat-button matStepperPrevious>{{"CUSTOMER.BACK" | translate}}</button>
            <button mat-button (click)="createCustomerAccount()"
                [disabled]="thirdInformation.invalid && basicInformation.invalid">{{"REGISTER.TITLE" |
                translate}}</button>
        </div>
    </mat-step>
</mat-horizontal-stepper>
